var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1024,
    "node-id": 1,
    sillyvg: "true",
    "template-height": 1024,
    "template-width": 1024,
    viewBox: "0 0 1024 1024",
    width: 1024,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    "node-id": 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "node-id": 77
  }, /*#__PURE__*/React.createElement("g", {
    "node-id": 78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 0.00 L 1024.00 0.00 L 1024.00 1024.00 L 0.00 1024.00 Z",
    fill: "none",
    "group-id": "1,2",
    "node-id": 35,
    stroke: "none",
    "target-height": 1024,
    "target-width": 1024,
    "target-x": 0,
    "target-y": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 856.49 129.50 L 862.83 155.24 C 863.54 158.13 865.79 160.38 868.68 161.09 L 894.42 167.44 C 895.31 167.66 895.93 168.46 895.93 169.38 C 895.93 170.30 895.31 171.10 894.42 171.32 L 868.68 177.67 C 865.79 178.38 863.54 180.63 862.83 183.52 L 856.49 209.26 C 856.27 210.16 855.47 210.79 854.54 210.79 C 853.62 210.79 852.82 210.16 852.60 209.26 L 846.26 183.52 C 845.55 180.63 843.29 178.38 840.40 177.67 L 814.66 171.32 C 813.77 171.10 813.15 170.30 813.15 169.38 C 813.15 168.46 813.77 167.66 814.66 167.44 L 840.40 161.09 C 843.29 160.38 845.55 158.13 846.26 155.24 L 852.60 129.50 C 852.82 128.60 853.62 127.97 854.54 127.97 C 855.47 127.97 856.27 128.60 856.49 129.50 Z",
    fill: "#ccdeff",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 37,
    stroke: "none",
    "target-height": 82.828384,
    "target-width": 82.78754,
    "target-x": 813.1463,
    "target-y": 127.965805
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 508.62 113.94 L 506.67 135.22 C 506.46 137.61 507.58 139.92 509.59 141.22 L 527.52 152.84 C 528.13 153.24 528.39 154.01 528.16 154.70 C 527.92 155.39 527.25 155.84 526.52 155.79 L 505.24 153.85 C 502.86 153.63 500.55 154.75 499.24 156.76 L 487.63 174.69 C 487.25 175.36 486.45 175.67 485.72 175.43 C 484.98 175.19 484.53 174.46 484.63 173.69 L 486.63 152.41 C 486.85 150.02 485.73 147.71 483.72 146.41 L 465.79 134.79 C 465.12 134.41 464.81 133.61 465.05 132.88 C 465.29 132.14 466.02 131.69 466.79 131.79 L 488.06 133.79 C 490.45 134.00 492.75 132.88 494.06 130.87 L 505.68 112.94 C 506.09 112.34 506.84 112.09 507.53 112.32 C 508.22 112.55 508.66 113.22 508.62 113.94 Z",
    fill: "#ccdeff",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 39,
    stroke: "none",
    "target-height": 63.588425,
    "target-width": 63.587036,
    "target-x": 464.80634,
    "target-y": 112.08522
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 142.36 640.69 L 158.49 659.15 C 160.30 661.22 163.11 662.11 165.78 661.47 L 189.62 655.77 C 190.45 655.58 191.29 655.97 191.68 656.73 C 192.07 657.48 191.90 658.40 191.26 658.96 L 172.81 675.09 C 170.74 676.90 169.84 679.71 170.48 682.38 L 176.19 706.21 C 176.39 707.04 176.00 707.89 175.24 708.28 C 174.49 708.67 173.56 708.50 173.00 707.86 L 156.87 689.41 C 155.06 687.34 152.25 686.44 149.58 687.08 L 125.74 692.78 C 124.91 692.98 124.06 692.59 123.67 691.83 C 123.28 691.08 123.45 690.15 124.09 689.59 L 142.55 673.46 C 144.62 671.65 145.52 668.84 144.88 666.17 L 139.17 642.34 C 138.97 641.51 139.36 640.66 140.12 640.27 C 140.87 639.88 141.80 640.05 142.36 640.69 Z",
    fill: "#ccdeff",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 41,
    stroke: "none",
    "target-height": 68.79773,
    "target-width": 68.7926,
    "target-x": 123.276184,
    "target-y": 639.87616
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 880.00 472.00 C 880.00 485.25 869.25 496.00 856.00 496.00 C 842.75 496.00 832.00 485.25 832.00 472.00 C 832.00 458.75 842.75 448.00 856.00 448.00 C 869.25 448.00 880.00 458.75 880.00 472.00 Z",
    fill: "#ccdeff",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 43,
    stroke: "none",
    "target-height": 48,
    "target-width": 48,
    "target-x": 832,
    "target-y": 448
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.00 288.00 L 736.00 288.00 C 753.67 288.00 768.00 302.33 768.00 320.00 L 768.00 864.00 C 768.00 881.67 753.67 896.00 736.00 896.00 L 256.00 896.00 L 256.00 896.00 L 256.00 320.00 C 256.00 302.33 270.33 288.00 288.00 288.00 Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 45,
    stroke: "none",
    "target-height": 608,
    "target-width": 512,
    "target-x": 256,
    "target-y": 288
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 736.00 900.00 L 252.00 900.00 L 252.00 320.00 C 252.00 300.12 268.12 284.00 288.00 284.00 L 736.00 284.00 C 755.88 284.00 772.00 300.12 772.00 320.00 L 772.00 864.00 C 772.00 883.88 755.88 900.00 736.00 900.00 Z M 260.00 892.00 L 736.00 892.00 C 751.46 892.00 764.00 879.46 764.00 864.00 L 764.00 320.00 C 764.00 304.54 751.46 292.00 736.00 292.00 L 288.00 292.00 C 272.54 292.00 260.00 304.54 260.00 320.00 Z",
    fill: "#101129",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 47,
    stroke: "none",
    "target-height": 616,
    "target-width": 520,
    "target-x": 252,
    "target-y": 284
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.00 832.00 L 672.00 800.00 C 672.00 782.33 657.67 768.00 640.00 768.00 L 224.00 768.00 C 206.33 768.00 192.00 782.33 192.00 800.00 L 192.00 832.00 C 192.00 867.35 220.65 896.00 256.00 896.00 L 736.00 896.00 C 700.65 896.00 672.00 867.35 672.00 832.00 Z",
    fill: "#80adff",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 49,
    stroke: "none",
    "target-height": 128,
    "target-width": 544,
    "target-x": 192,
    "target-y": 768
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 736.00 900.00 L 256.00 900.00 C 218.46 899.96 188.04 869.54 188.00 832.00 L 188.00 800.00 C 188.00 780.12 204.12 764.00 224.00 764.00 L 640.00 764.00 C 659.88 764.00 676.00 780.12 676.00 800.00 L 676.00 832.00 C 676.04 865.12 702.88 891.96 736.00 892.00 Z M 224.00 772.00 C 208.54 772.00 196.00 784.54 196.00 800.00 L 196.00 832.00 C 196.04 865.12 222.88 891.96 256.00 892.00 L 704.00 892.00 C 681.85 880.17 668.01 857.11 668.00 832.00 L 668.00 800.00 C 668.00 784.54 655.46 772.00 640.00 772.00 Z",
    fill: "#101129",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 51,
    stroke: "none",
    "target-height": 136,
    "target-width": 548,
    "target-x": 188,
    "target-y": 764
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 246.23 236.62 C 267.01 236.62 283.91 219.41 283.91 198.26 C 283.92 190.66 281.69 183.23 277.50 176.89 C 271.32 172.64 264.00 170.37 256.50 170.37 C 255.65 170.37 254.75 170.37 253.68 170.49 C 252.25 170.59 250.91 169.79 250.32 168.49 C 248.88 165.39 247.01 162.51 244.75 159.95 L 243.40 160.03 C 241.97 160.14 240.63 159.34 240.04 158.03 C 239.28 156.37 238.38 154.78 237.36 153.26 C 227.99 146.50 215.31 142.48 201.69 142.48 C 173.36 142.48 150.31 159.69 150.31 180.84 C 150.32 181.75 149.96 182.64 149.32 183.29 C 148.68 183.94 147.81 184.31 146.89 184.32 C 126.11 184.32 109.21 198.40 109.21 215.71 C 109.23 220.71 110.64 225.61 113.27 229.86 C 120.23 234.34 128.34 236.69 136.61 236.63 Z",
    fill: "#80adff",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 53,
    stroke: "none",
    "target-height": 94.213196,
    "target-width": 174.71463,
    "target-x": 109.21,
    "target-y": 142.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 246.23 244.11 L 232.53 244.11 C 230.32 244.11 228.53 242.32 228.53 240.11 C 228.53 237.90 230.32 236.11 232.53 236.11 L 246.23 236.11 C 266.69 236.11 283.33 219.11 283.33 198.26 C 283.33 177.41 266.69 160.42 246.23 160.42 C 245.40 160.42 244.52 160.42 243.46 160.53 C 241.79 160.66 240.22 159.73 239.52 158.21 C 232.52 142.84 213.15 132.52 191.43 132.52 C 163.43 132.52 140.62 149.52 140.62 170.37 C 140.62 172.58 138.83 174.37 136.62 174.37 C 116.16 174.37 99.52 188.21 99.52 205.24 C 99.52 222.27 116.16 236.11 136.62 236.11 L 205.13 236.11 C 207.34 236.11 209.13 237.90 209.13 240.11 C 209.13 242.32 207.34 244.11 205.13 244.11 L 136.62 244.11 C 111.75 244.11 91.52 226.67 91.52 205.24 C 91.52 184.90 109.73 168.17 132.83 166.50 C 135.35 143.02 160.67 124.50 191.43 124.50 C 215.09 124.50 236.43 135.61 245.56 152.40 L 246.23 152.40 C 271.10 152.40 291.33 172.96 291.33 198.24 C 291.33 223.52 271.10 244.11 246.23 244.11 Z",
    fill: "#101129",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 55,
    stroke: "none",
    "target-height": 119.610016,
    "target-width": 199.81,
    "target-x": 91.52,
    "target-y": 124.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 887.51 888.91 C 908.31 888.91 925.22 869.18 925.22 844.91 C 925.27 836.32 923.06 827.87 918.81 820.40 C 912.86 815.60 905.46 812.96 897.81 812.91 C 896.96 812.91 896.06 812.96 894.98 813.05 C 893.47 813.12 892.10 812.18 891.62 810.75 C 890.20 807.26 888.31 803.98 886.00 801.00 L 884.66 801.09 C 883.15 801.16 881.78 800.22 881.30 798.79 C 880.53 796.90 879.64 795.08 878.61 793.32 C 868.49 785.20 855.88 780.83 842.91 780.95 C 814.55 780.95 791.48 800.69 791.48 824.95 C 791.62 827.00 790.10 828.78 788.05 828.95 C 767.26 828.95 750.34 845.10 750.34 864.95 C 750.34 870.61 751.74 876.19 754.40 881.18 C 761.13 886.25 769.34 888.98 777.77 888.95 Z",
    fill: "#80adff",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 57,
    stroke: "none",
    "target-height": 108.14545,
    "target-width": 174.92883,
    "target-x": 750.34,
    "target-y": 780.8306
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 887.51 896.92 L 873.79 896.92 C 871.58 896.92 869.79 895.13 869.79 892.92 C 869.79 890.71 871.58 888.92 873.79 888.92 L 887.51 888.92 C 907.99 888.92 924.65 869.18 924.65 844.92 C 924.65 820.66 907.99 800.92 887.51 800.92 C 886.69 800.92 885.82 800.92 884.78 801.05 C 883.02 801.20 881.37 800.19 880.72 798.55 C 873.63 780.82 854.32 768.92 832.65 768.92 C 804.65 768.92 781.79 788.65 781.79 812.92 C 781.79 815.13 780.00 816.92 777.79 816.92 C 757.31 816.92 740.65 833.06 740.65 852.92 C 740.65 872.78 757.31 888.92 777.79 888.92 L 846.37 888.92 C 848.58 888.92 850.37 890.71 850.37 892.92 C 850.37 895.13 848.58 896.92 846.37 896.92 L 777.79 896.92 C 752.90 896.92 732.65 877.18 732.65 852.92 C 732.65 829.92 750.85 810.98 773.95 809.07 C 776.19 782.19 801.66 760.92 832.65 760.92 C 856.48 760.92 877.92 773.66 886.99 792.92 L 887.51 792.92 C 912.40 792.92 932.65 816.24 932.65 844.92 C 932.65 873.60 912.40 896.92 887.51 896.92 Z",
    fill: "#101129",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 59,
    stroke: "none",
    "target-height": 136,
    "target-width": 200,
    "target-x": 732.65,
    "target-y": 760.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 223.35 448.00 L 415.35 448.00 C 433.02 448.00 447.35 462.33 447.35 480.00 L 447.35 544.00 C 447.35 561.67 433.02 576.00 415.35 576.00 L 223.35 576.00 C 205.68 576.00 191.35 561.67 191.35 544.00 L 191.35 480.00 C 191.35 462.33 205.68 448.00 223.35 448.00 Z",
    fill: "#ffdc8a",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 61,
    stroke: "none",
    "target-height": 128,
    "target-width": 256,
    "target-x": 191.35,
    "target-y": 448
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.00 608.00 L 496.00 608.00 C 504.84 608.00 512.00 615.16 512.00 624.00 L 512.00 624.00 C 512.00 632.84 504.84 640.00 496.00 640.00 L 336.00 640.00 C 327.16 640.00 320.00 632.84 320.00 624.00 L 320.00 624.00 C 320.00 615.16 327.16 608.00 336.00 608.00 Z",
    fill: "#ffdc8a",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 63,
    stroke: "none",
    "target-height": 32,
    "target-width": 192,
    "target-x": 320,
    "target-y": 608
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.00 384.00 C 384.00 401.67 369.67 416.00 352.00 416.00 C 334.33 416.00 320.00 401.67 320.00 384.00 C 320.00 366.33 334.33 352.00 352.00 352.00 C 369.67 352.00 384.00 366.33 384.00 384.00 Z",
    fill: "#81e6c1",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 65,
    stroke: "none",
    "target-height": 64,
    "target-width": 64,
    "target-x": 320,
    "target-y": 352
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 352.00 420.00 C 332.12 420.00 316.00 403.88 316.00 384.00 C 316.00 364.12 332.12 348.00 352.00 348.00 C 371.88 348.00 388.00 364.12 388.00 384.00 C 388.00 403.88 371.88 420.00 352.00 420.00 Z M 352.00 356.00 C 336.54 356.00 324.00 368.54 324.00 384.00 C 324.00 399.46 336.54 412.00 352.00 412.00 C 367.46 412.00 380.00 399.46 380.00 384.00 C 380.00 368.54 367.46 356.00 352.00 356.00 Z",
    fill: "#101129",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 67,
    stroke: "none",
    "target-height": 72,
    "target-width": 72,
    "target-x": 316,
    "target-y": 348
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 512.00 384.00 C 512.00 401.67 497.67 416.00 480.00 416.00 C 462.33 416.00 448.00 401.67 448.00 384.00 C 448.00 366.33 462.33 352.00 480.00 352.00 C 497.67 352.00 512.00 366.33 512.00 384.00 Z",
    fill: "#ffdc8a",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 69,
    stroke: "none",
    "target-height": 64,
    "target-width": 64,
    "target-x": 448,
    "target-y": 352
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.00 420.00 C 460.12 420.00 444.00 403.88 444.00 384.00 C 444.00 364.12 460.12 348.00 480.00 348.00 C 499.88 348.00 516.00 364.12 516.00 384.00 C 516.00 403.88 499.88 420.00 480.00 420.00 Z M 480.00 356.00 C 464.54 356.00 452.00 368.54 452.00 384.00 C 452.00 399.46 464.54 412.00 480.00 412.00 C 495.46 412.00 508.00 399.46 508.00 384.00 C 508.00 368.54 495.46 356.00 480.00 356.00 Z",
    fill: "#101129",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 71,
    stroke: "none",
    "target-height": 72,
    "target-width": 72,
    "target-x": 444,
    "target-y": 348
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 704.00 452.00 C 701.79 452.00 700.00 450.21 700.00 448.00 L 700.00 416.00 C 700.00 413.79 701.79 412.00 704.00 412.00 C 706.21 412.00 708.00 413.79 708.00 416.00 L 708.00 448.00 C 708.00 450.21 706.21 452.00 704.00 452.00 Z",
    fill: "#101129",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 73,
    stroke: "none",
    "target-height": 40,
    "target-width": 8,
    "target-x": 700,
    "target-y": 412
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 704.00 612.00 C 701.79 612.00 700.00 610.21 700.00 608.00 L 700.00 480.00 C 700.00 477.79 701.79 476.00 704.00 476.00 C 706.21 476.00 708.00 477.79 708.00 480.00 L 708.00 608.00 C 708.00 610.21 706.21 612.00 704.00 612.00 Z",
    fill: "#101129",
    fillRule: "nonzero",
    "group-id": "1,2",
    "node-id": 75,
    stroke: "none",
    "target-height": 136,
    "target-width": 8,
    "target-x": 700,
    "target-y": 476
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.9f8d60b0f867378dcecf091767c150f1.svg";
export { ForwardRef as ReactComponent };